import { AfterViewChecked, Directive, ElementRef, OnInit } from '@angular/core';

@Directive({
  selector: '[shortTooltip]'
})
export class TooltipDirective implements OnInit, AfterViewChecked {

  constructor(private element: ElementRef) {
    //  console.log("text length", this.element.nativeElement);
  }
  ngOnInit() {
    //console.log("text length", this.element.nativeElement.innerText);
  }
  ngAfterViewChecked() {
    let content = this.element.nativeElement.innerText;
    if (content.length > 50)
    this.element.nativeElement.innerText=content.substr(0,100)+"..."

  }

}
